import _ from 'lodash';
import moment from 'moment';
import { computed, observable, toJS, makeObservable } from 'mobx';

class CheckInSummary {
  selected = false;
  completedAt;

  constructor(checkin) {
    makeObservable(this, {
      selected: observable,
      completedAt: observable,
      date: computed,
      completed: computed
    });

    this.merge(checkin);
  }

  get date() {
    return moment(this.createdAt).format('MMMM Do, YYYY');
  }

  get completed() {
    return !!this.completedAt;
  }

  merge(partialCheckin) {
    _.merge(this, partialCheckin);
  }

  toJS() {
    return toJS(this);
  }
}

export default CheckInSummary;
